module.exports = __webpack_public_path__ + "img/ereszkalkulator_26_minoseg_standard_szurke.b6c323fa.png";